const getters = {
    all_routes: state => state.menu.routes,
    device: state => state.app.device
}
export default getters